import { CSSInterpolation, darken } from '@mui/material';

import { tableBlack, tableGrey, tableWhite } from '../variables/variables';

export const tablePaginationInterpolation: CSSInterpolation = {
  color: '#000',
  '.btn-first-page': {
    order: 3,
  },
  '.btn-prev-page': {
    order: 4,
  },
  '.btn-next-page': {
    order: 6,
  },
  '.btn-last-page': {
    order: 7,
  },

  button: {
    backgroundColor: tableBlack,
    borderRadius: '5px',
    padding: '6px',
    color: tableWhite,

    '&:disabled': {
      color: tableWhite,
      backgroundColor: tableGrey,
    },

    '&:hover': {
      color: darken(tableWhite, 0.1),
      backgroundColor: tableBlack,
    },
  },
};
